module.exports = __webpack_public_path__ + "assets/b32ad0e3f979400d3653dd13459777ae.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-vietnamese-500-normal.woff2
// module id = 2644
// module chunks = 121